// extracted by mini-css-extract-plugin
export var anchor = "_2u-0";
export var discard = "_2u-4";
export var muiTooltipTooltip = "_2u-6";
export var notificationBar = "_2u-3";
export var saveButtonHoverSlotWrapper = "_2u-5";
export var show = "_2u-2";
export var spacer = "_2u-1";